import { atom } from 'jotai';

/**
 * Atom to track whether the applicant has visited the confirm details step
 * This is used to determine if the Quick Navigate button should be shown
 */
export const hasVisitedConfirmDetailsAtom = atom<boolean>(false);
